<template>
  <a-drawer
    :closable="closable"
    :placement="placement"
    :visible="value"
    :width="width"
    :mask-closable="maskClosable"
    :destroy-on-close="destroyOnClose"
    :wrap-class-name="wrapClassName + (buttonFlag?' button-drawer-body':'') + ' dol-drawer'"
    :get-container="getContainer"
    @close="close"
  >
    <slot name="title" slot="title">
      {{title}}
    </slot>
    <slot/>
    <div class="drawer-bottom" v-if="buttonFlag">
      <slot name="button">
        <a-button class="card-button" @click="close"> {{cancelText}}</a-button>
        <a-button class="card-button" type="primary" :loading="buttonLoading" @click="submit"> {{submitText}}</a-button>
      </slot>
    </div>
  </a-drawer>
</template>

<script>
export default {
  name: "dol-drawer",
  props: {
    title: {type: String},
    getContainer: {},
    closable: {type: Boolean, default: true},
    destroyOnClose: {type: Boolean, default: false},
    placement: {type: String},
    value: {type: Boolean, default: false},
    width: {default: 600},
    buttonFlag: {type: Boolean, default: false},
    buttonLoading: {type: Boolean, default: false},

    cancelText: {type: String, default: '取消'},
    submitText: {type: String, default: '保存'},
    wrapClassName: {type: String, default: ''},
    maskClosable:{type:Boolean, default:true}
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    submit() {
      this.$emit('submit');
    },
  }
}
</script>

<style lang="scss">
.drawer-bottom {
  position: absolute;
  z-index: 1;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
.button-drawer-body{
  .ant-drawer-body{
    margin-bottom: 50px;
  }
}
</style>
